import { NextPage } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import React from 'react'

import { getFloatingMenu } from '@/services/apps'
import { getJdihCategoriesList, getJdihHeader } from '@/services/jdih'
import { wrapper } from '@/store'

import Jdih from './Jdih'
const Page: NextPage = () => {
  return (
    <main className='min-h-screen bg-gray-100'>
      <Jdih />
    </main>
  )
}

export const getProps = wrapper.getServerSideProps((store) => async ({ locale }) => {
  const requestCategory = {
    params: { skip: 0, limit: 1000 },
    headers: { 'Accept-Language': String(locale) },
  }
  await Promise.all([
    store.dispatch(getJdihHeader.initiate({ headers: { ...requestCategory.headers } })),
    store.dispatch(getJdihCategoriesList.initiate(requestCategory)),
    store.dispatch(getFloatingMenu.initiate({ headers: { ...requestCategory.headers } })),
  ])
  return {
    props: {
      ...(await serverSideTranslations(String(locale), ['common', 'jdih'])),
    },
  }
})

export default Page
